<template>
    <div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">组装件名称</th>
                <th width="120" style="text-align: left">分类</th>
                <th width="120" style="text-align: left">品牌</th>
                <th width="120" style="text-align: left">型号</th>
                <th width="150" style="text-align: left">规格</th>
                <th width="100" style="text-align: right">数量</th>
                <th width="100" style="text-align: left">单位</th>
                <th width="80" align="left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="accAsmbl, index in accAsmbls">
                <td style="text-align: left">{{accAsmbl.name}}</td>
                <td style="text-align: left">{{accAsmbl.catName}}</td>
                <td style="text-align: left">{{accAsmbl.brandName}}</td>
                <td style="text-align: left">{{accAsmbl.model}}</td>
                <td style="text-align: left">{{accAsmbl.fixedSpec}}</td>
                <td style="text-align: right">
                    <el-input type="text" @change="countChanges(accAsmbl, index);" v-model="accAsmbl.count"></el-input>
                </td>
                <td style="text-align: left">{{accAsmbl.theUnit}}</td>
                <td align="left"><a class="swb-btn-link" @click="removeAccAsmbl(accAsmbl,index)">移除</a></td>
            </tr>
            <tr class="row">
                <td colspan="8" class="display-none">
                    <div class="no-data">
                        <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
                        <span class="">暂无数据 . . .</span>
                    </div>
                </td>
            </tr>
            </tbody>
            <tfoot class="foot">
            <tr class="row">
                <td colspan="8">
                    <div class="swb-btn-link" @click="selectAccAsmblAndAdoptedDevice()">
                            <span>
                                <i class="icon iconfont icon-jiahao mr5"></i>选择组装件
                            </span>
                    </div>
                </td>
            </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import appConf from '../../app.conf';
    import { showAsmblAccDefSelectDlg, showMerchtDevcDefRelMackDlg } from '../asmblAcc/dialog'

    import devcDefApi from '../../api/devcDef'

    export default {
        name: 'swb-mercht-devc-def-rel-acc-asmbl',
        desc: '资产定义关联组装件',
        props: {
            devcDef: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            activeName: null
        },
        watch: {
            activeName: function (newValue, oldValue) {
                if(newValue == 'first') {
                    this.getDataList();
                }
            }
        },
        data: function () {
            return {
                //
                accAsmbls: [],
                asmblIds: []
            }
        },
        created: function () {
            if(!Utils.isNoB(this.devcDef) && this.devcDef.id > 0) {
                this.getDataList();
            }
        },
        methods: {
            // 获取已关联的组装件信息
            getDataList(){
                let self = this;
                //
                let filterItems = {};
                filterItems.devcDefId = self.devcDef.id;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                devcDefApi.getAsmblAccDefList(filterItems, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        let accAsmbls = result.data || [];
                        let accAsmblList = [];
                        accAsmbls.forEach(function (item) {
                            let accAsmbl = {};
                            accAsmbl.name = item.name;
                            accAsmbl.catName = item.catName;
                            accAsmbl.brandName = item.brandName;
                            accAsmbl.model = item.model;
                            accAsmbl.fixedSpec = item.fixedSpec;
                            accAsmbl.theUnit = item.theUnit;
                            accAsmbl.modelSpec = item.modelSpec;
                            accAsmbl.accDefTitle = item.title;
                            accAsmbl.accDefId = item.id;
                            accAsmbl.count = item.accCount;
                            accAsmblList.push(accAsmbl);
                        });

                        self.accAsmbls = Utils.merge([], accAsmblList);
                        //
                        self.asmblIds = Utils.merge([], accAsmbls.pluck("id"));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 数量校验
            countChanges: function (row, index) {
                let count = row.count;
                if(!Utils.isNoB(count) && !Utils.isNaturalStr(count)) {
                    count = null;
                    MsgBox.warning("请输入大于0的整数！");
                }
                let accAsmblList = this.accAsmbls || [];
                let accAsmbl = accAsmblList[index];
                accAsmbl.count = count;
                this.accAsmbls = Utils.merge([], accAsmblList);
            },
            // 选择组装件
            selectAccAsmbl: function () {
                let self = this;
                let parmas = {
                    checkIds: self.devcDef.accDefIds || [],
                    needDisabled: true,
                    filter: {
                        retailerId: self.devcDef.retailerId,
                        disabled: false
                    }
                };
                showAsmblAccDefSelectDlg(parmas, function (asmblAccList, theDlg) {
                    theDlg.close();
                    asmblAccList = asmblAccList || [];
                    if(asmblAccList.length > 0) {
                        let accAsmbls = self.accAsmbls || [];
                        accAsmbls = accAsmbls.concat(asmblAccList);
                        self.accAsmbls = Utils.merge([], accAsmbls);
                    }
                });
            },
            selectAccAsmblAndAdoptedDevice: function () {
                let self = this;
                let accAsmbls = this.accAsmbls || [];
                let asmblIds = self.asmblIds;
                let deviceIds = [];
                accAsmbls.forEach(function (item) {
                    if(!Utils.isNoB(item.accDefId) && asmblIds.indexOf(item.accDefId) < 0) {
                        asmblIds.push(item.accDefId);
                    }
                    if(!Utils.isNoB(item.deviceId)) {
                        deviceIds.push(item.deviceId);
                    }
                });
                let asmblFilter = {
                    retailerId: self.devcDef.retailerId,
                    disabled: false
                };
                let deviceFilter = {
                    retailerId: self.devcDef.retailerId,
                    disabled: false,
                };
                let parmas = {
                    asmblIds: asmblIds,
                    deviceIds: deviceIds,
                    asmblFilter: asmblFilter,
                    deviceFilter: deviceFilter
                };

                showMerchtDevcDefRelMackDlg(parmas, function (resultData, theDlg) {
                    theDlg.close();
                    let asmblAccList = resultData.asmblAccList || [];
                    let deviceList = resultData.deviceList || [];
                    let accAsmbls = self.accAsmbls || [];
                    if(deviceList.length > 0) {
                        deviceList.forEach(function (item) {
                            let accAsmbl = {};
                            accAsmbl.name = item.name;
                            accAsmbl.catName = item.goodsCatName;
                            accAsmbl.brandName = item.goodsBrandName;
                            accAsmbl.model = item.model;
                            accAsmbl.fixedSpec = item.fixedSpec;
                            accAsmbl.theUnit = item.unit;
                            accAsmbl.catId = item.goodsCatId;
                            accAsmbl.brandId = item.goodsBrandId;
                            accAsmbl.modelSpec = item.modelSpec;
                            accAsmbl.unit = item.unit;
                            accAsmbl.accDefTitle = item.title;
                            accAsmbl.deviceId = item.id;
                            accAsmbl.accDefId = item.assetDefId;
                            accAsmbls.push(accAsmbl);
                        });
                    }
                    if(asmblAccList.length > 0) {
                        asmblAccList.forEach(function (item) {
                            let accAsmbl = {};
                            accAsmbl.name = item.name;
                            accAsmbl.catName = item.catName;
                            accAsmbl.brandName = item.brandName;
                            accAsmbl.model = item.model;
                            accAsmbl.fixedSpec = item.fixedSpec;
                            accAsmbl.theUnit = item.theUnit;
                            accAsmbl.modelSpec = item.modelSpec;
                            accAsmbl.accDefTitle = item.title;
                            accAsmbl.accDefId = item.id;
                            accAsmbls.push(accAsmbl);
                        });
                    }
                    self.accAsmbls = Utils.merge([], accAsmbls);
                })
            },
            showMerchtDevcDefRelMackDlg: function () {

            },
            // 移除组装件
            removeAccAsmbl: function (row, index) {
                let accAsmblList = this.accAsmbls || [];
                accAsmblList.splice(index, 1);
                this.accAsmbls = Utils.merge([], accAsmblList);
            },
            // 返回数据
            getDlgResult: function () {
                let result = {};
                let selectList = this.accAsmbls || [];
                let errMsg = '';
                for(let i = 0; i < selectList.length; i++) {
                    let item = selectList[i];
                    if(Utils.isNoB(item.count)) {
                        if(Utils.isNoB(errMsg)) {
                            errMsg = '组装件【' + item.name + '】';
                        } else {
                            errMsg += '、【' + item.name + '】';
                        }
                    }
                }
                if(!Utils.isNoB(errMsg)) {
                    result.type = "warn";
                    result.message = errMsg + "请输入具体的数量！";
                } else {
                    let asmblAccDefDto = {};
                    asmblAccDefDto.devcDefId = this.devcDef.id;
                    asmblAccDefDto.merchtDevcAccAsmblRelList = selectList;
                    result.data = asmblAccDefDto;
                    result.type = "info";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcDefRelAccAsmbl.vue